export class SumupGroup {
  id: number
  school_id: number
  exec_date: string
  name: string
  exec_times: number

  constructor(sumupGroup: any){
    this.id = sumupGroup.id;
    this.school_id = sumupGroup.school_id;
    this.exec_date = sumupGroup.exec_date;
    this.name = sumupGroup.name;
    this.exec_times = sumupGroup.exec_times;
  }
}

export class SumupTotalAll {
  examinee_count: number
  allot: number
  avg_score: string
  std_dev: string
  min_score: number
  max_score: number

  constructor(sumupTotalAll: any){
    this.examinee_count = sumupTotalAll.examinee_count;
    this.allot = sumupTotalAll.allot;
    this.avg_score = sumupTotalAll.avg_score.toFixed(1);
    this.std_dev = sumupTotalAll.std_dev.toFixed(1);
    this.min_score = sumupTotalAll.min_score;
    this.max_score = sumupTotalAll.max_score;
  }
}

export class SumupPart1All {
  part1: string
  content: string
  examinee_count: number
  allot: number
  avg_score: string
  std_dev: string
  min_score: number
  max_score: number
  score_rate: number

  constructor(sumupPart1All: any){
    this.part1 = sumupPart1All.part1;
    this.content = sumupPart1All.content;
    this.examinee_count = sumupPart1All.examinee_count;
    this.allot = sumupPart1All.allot;
    this.avg_score = sumupPart1All.avg_score.toFixed(1);
    this.std_dev = sumupPart1All.std_dev.toFixed(1);
    this.min_score = sumupPart1All.min_score;
    this.max_score = sumupPart1All.max_score;
    this.score_rate = sumupPart1All.score_rate;
  }
}

export class SumupFieldAll {
  part1: string
  part2: string
  part3: string
  question_content: string
  allot: number
  score_rate: number

  constructor(sumupFieldAll: any){
    this.part1 = sumupFieldAll.part1;
    this.part2 = sumupFieldAll.part2;
    this.part3 = sumupFieldAll.part3;
    this.question_content = sumupFieldAll.question_content;
    this.allot = sumupFieldAll.allot;
    this.score_rate = sumupFieldAll.score_rate;
  }
}